/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Insert_MarkerInputs */



/**
* | output |
* | --- |
* | "Insert Marker" |
*
* @param {Shortcut_Keys_Name_Insert_MarkerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_insert_marker = /** @type {((inputs?: Shortcut_Keys_Name_Insert_MarkerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Insert_MarkerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer un marqueur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Marker einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci marcatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить маркер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar marcador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーを挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir marcador")
	return /** @type {LocalizedString} */ ("Insert Marker")
});